import deburr from 'lodash/deburr';

export const normalizeStr = (str) => deburr(str.toLowerCase().trim());
